require('./collectiveLandingProductBox.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { hash } = require('utilities/hash');
const { getLastNChars } = require('utilities/stringHelper');
// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');
const OKTag = require('components/commons/OKTag/OKTag');

class CollectiveLandingProductBox extends React.Component {

    getHashedPan(cardNumber, immCards) {
        let hashedPan = '';

        immCards.get('byId').every((immCard) => {
            const fullPanNumber = immCard.getIn(['interventionList', 0, 'pan']);
            const cardNumberLastDigits = getLastNChars(immCard.get('number'), 4);
            const isCardNumberMatched = getLastNChars(cardNumber, 4) === cardNumberLastDigits;
            if (isCardNumberMatched) {
                hashedPan = hash(fullPanNumber);
            }
            return !isCardNumberMatched;
        });

        return hashedPan;
    }

    render() {
        const { immCards, immProductDetails } = this.props;

        const imageURL = immProductDetails.get('imageURL');
        const imageContent = imageURL && (
            <img className="collective-landing-product-box__image" src={imageURL} />
        );

        const title = immProductDetails.get('productTitle');
        const titleContent = title && (
            <HTMLSafeInjector
                customClass="collective-landing-product-box__title"
                message={title}
            />
        );

        const description = immProductDetails.get('productDescription');
        const body = description && (
            <HTMLSafeInjector
                customClass="collective-landing-product-box__description"
                message={description}
            />
        );

        const cardNumber =  immProductDetails.get('cardNumber');
        const hashedPan = this.getHashedPan(cardNumber, immCards);
        const link = immProductDetails.get('ctaLink').replace('${hashedPan}', hashedPan);
        const ctaText = immProductDetails.get('isProductHired') ?
            <FormattedText value="colectivesLanding-colectivesLanding_hiredPrimaryCta" /> :
            <FormattedText value="colectivesLanding-colectivesLanding_nonHiredPrimaryCtaButtonText" />

        let tagContent;
        if (immProductDetails.get('isProductHired')) {
            const hiredText = formatText('colectivesLanding-colectivesLanding_hiredExclusiveTagText');
            tagContent = (
                <div className="pull-right collective-landing-product-box__tag">
                    <OKTag content={hiredText} type={"success"} context={"arrow"} emphasis={true} />
                </div>
            );
        }

        return (
            <section
                className="collective-landing-product-box public-cms-styles"
            >
                <section className="collective-landing-product-box__content-section row">
                    <div className="col-md-6 collective-landing-product-box__image">
                        {imageContent}
                    </div>
                    <div className="col-md-6">
                        <div className="collective-landing-product-box__details">
                            {tagContent}
                            {titleContent}
                            <div className="collective-landing-product-box__details-step">
                                {body}
                            </div>
                            <div className="collective-landing-product-box__details-footer">
                                <div className="collective-landing-product-box__details-footer-button pull-right">
                                    <OKButton
                                        modifier="primary"
                                        size="small"
                                        to={link}
                                    >
                                        {ctaText}
                                    </OKButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </section>
        )
    }
}

CollectiveLandingProductBox.propTypes = {
    immProductDetails: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
};

module.exports = CollectiveLandingProductBox;
